/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { RemoteJobSummary } from './remoteJobSummary';

export interface RemoteJobListResponse {
  jobs: RemoteJobSummary[];
  next_cursor?: string | null;
  sync_pending?: boolean;
}
